import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/Form.css';
import logo from '../assets/images/Logo.svg';
import check from '../assets/images/check.svg';
import { useLocation } from 'react-router-dom';

const responseSubmissionMapping = {
	question: 'Question Posted Successfully',
	apply: 'Job Application Sent!',
	reject: 'Job Rejected Successfully!',
};

function JobResponse() {
	let navigate = useNavigate();
	const location = useLocation();
	const { key } = location.state.params;
	const handlePath = e => {
		e.preventDefault();
		navigate(`/`);
	};

	return (
		<div className='main-container form-bg-color form-bg-log'>
			<img src={logo} className='form-logo' alt='logo' />
			<div className='form-container'>
				<img
					src={check}
					style={{
						height: '7vmin',
						pointerEvents: 'none',
						marginBottom: '7px',
					}}
					alt='logo'
				/>
				<div className='form-label2-vmn'>
					{key
						? responseSubmissionMapping[key]
						: 'Question Posted Successfully'}
				</div>
				<button type='submit' onClick={handlePath} className='btn-send-code'>
					GO TO JOB LIST
				</button>
			</div>
		</div>
	);
}

export default JobResponse;
